import { createSlice } from "@reduxjs/toolkit";
import { isValidValue } from "../../helpers/FormHelper";


export const initialState = {
    isLogged: JSON.parse(localStorage.getItem('IS_LOGGED')) || false,
    token: JSON.parse(localStorage.getItem('TOKEN')) || null,
};


export const authSlice = createSlice({
    name: 'Auth',
    initialState,
    reducers: {
        setAuth: (state, action) => {
            state.token = action.payload;
            state.isLogged = isValidValue(action.payload);
            localStorage.setItem('TOKEN', JSON.stringify(action.payload));
            localStorage.setItem('IS_LOGGED', JSON.stringify(isValidValue(action.payload)));
        },
        resetAuth: (state) => {
            state.token = null;
            state.isLogged = false;
            localStorage.removeItem('TOKEN');
            localStorage.setItem('IS_LOGGED', 'false');
        },
    },
});

export const { setAuth, resetAuth } = authSlice.actions;


export default authSlice.reducer;